"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBannerLogo = function SvgBannerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 52,
    height: 52,
    rx: 8,
    fill: "#D2FF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.004 30.97a.968.968 0 0 1-.968-.967V18.479H9.167v12.559c0 1.974 1.6 3.573 3.573 3.573h7.212v-3.639h-5.944l-.004-.001Zm18.743-12.489v3.64h3.528v12.49h3.876v-12.49h3.682v-3.64H32.747Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.54 14.22a1.472 1.472 0 0 1-2.025.802 1.469 1.469 0 0 1-.802-1.795 1.43 1.43 0 0 1 .711-.9c.168-.093.222 0 .168.137a.946.946 0 0 0 .535 1.221c.458.153 1.062.03 1.183-.382.062-.222.268-.23.305-.039.039.153.077.574-.075.955v.001Zm-3.63 11.838v5.307c0 .344-.113.536-.571.572l-.497.039c-.42.039-.535-.191-.572-.535l-.42-5.041c-.04-.42.19-.727.648-.802l.65-.114c.573-.077.763.077.763.572v.002Zm9.51-14.396c.78-.305.741-1.221-.459-1.565-1.107-.314-1.947-.114-3.207.572l-.65.382c-1.298.764-1.717-.573-3.512-.458-1.986.153-3.513 2.1-2.75 4.201.267.726.078 1.221-.535 1.49l-7.755 3.59c-.688.305-.65.877-.039 1.26l.421.267c.534.343.572.801 0 1.145l-2.902 1.834c-1.299.802-.84 1.909.305 1.909h1.146a120.11 120.11 0 0 0 4.545-.191c.496-.039.763.077.763.572l-.114 6.529c0 .84.267 1.413 1.374 1.413H33.17c1.032 0 1.376-.536 1.376-1.222 0-1.068-.688-1.909-2.178-1.833l-1.374.114c-.458.038-.688-.192-.726-.688l-.458-5.727c-.039-.42.038-.688.574-.916 4.276-1.795 4.695-4.545 3.704-7.83-.306-.993-.802-1.833-1.223-2.483-.306-.458-.114-.726.268-.879l3.286-1.49v.004Z",
    fill: "#FF611D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBannerLogo);
var _default = exports["default"] = Memo;